<template>
  <div :id="componentId" class="spm1-host" :style="{ backgroundColor }">
    <div class="spm1-host-scroll">
      <div
        v-for="(host, idx) in hosts"
        :key="idx"
        class="spm1-host-card"
      >
        <div class="spm1-host-image-wrapper">
          <img class="spm1-host-image" referrerpolicy="no-referrer" :src="host.image" />
          <div class="spm1-host-name-bar">
            <span class="spm1-host-name" v-html="host.name"></span>
          </div>
        </div>
        <div class="spm1-host-intro-bar">
          <span class="spm1-host-intro">{{ host.introduction }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileHostSection',
  props: {
    componentId: {
      type: String,
      default: 'sp_one_module_9'
    }
  },
  data() {
    return {
      backgroundColor: 'rgba(255, 255, 255, 1)',
      hosts: [
        {
          name: '范&nbsp;&nbsp;红',
          introduction: '2026中国区域农业品牌发展',
          image: require('../../../special/SpecialOne/assets/img/FigmaDDSSlicePNG069168c115b2a926ff659c678ac25dcc.png')
        },
        {
          name: '范&nbsp;&nbsp;红',
          introduction: '2026中国区域农业品牌发展',
          image: require('../../../special/SpecialOne/assets/img/FigmaDDSSlicePNG069168c115b2a926ff659c678ac25dcc.png')
        },
        {
          name: '范&nbsp;&nbsp;红',
          introduction: '2026中国区域农业品牌发展',
          image: require('../../../special/SpecialOne/assets/img/FigmaDDSSlicePNG069168c115b2a926ff659c678ac25dcc.png')
        },
        {
          name: '范&nbsp;&nbsp;红',
          introduction: '2026中国区域农业品牌发展',
          image: require('../../../special/SpecialOne/assets/img/FigmaDDSSlicePNG069168c115b2a926ff659c678ac25dcc.png')
        }
      ]
    }
  }
}
</script>

<style scoped>
.spm1-host {
  width: 100%;
  padding: 12px;
  box-sizing: border-box;
}

.spm1-host-scroll {
  display: flex;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  gap: 8px;
  scrollbar-width: none;
}

.spm1-host-scroll::-webkit-scrollbar {
  display: none;
}

.spm1-host-card {
  flex-shrink: 0;
  width: 150px;
  border-radius: 8px;
  overflow: hidden;
}

.spm1-host-image-wrapper {
  position: relative;
  width: 100%;
}

.spm1-host-image {
  width: 100%;
  height: auto;
  display: block;
}

.spm1-host-name-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 28px;
  background: url('../../../special/SpecialOne/assets/img/FigmaDDSSlicePNG73297531bb1080ef078c4bbea576aa88.png') 100% no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.spm1-host-name {
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: Microsoft YaHei-Regular;
}

.spm1-host-intro-bar {
  background-image: linear-gradient(90deg, rgba(43, 131, 120, 1) 0, rgba(25, 196, 174, 1) 100%);
  width: 100%;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  box-sizing: border-box;
}

.spm1-host-intro {
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  font-family: Microsoft YaHei-Regular;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
